import { cn } from '@/lib/utils'

interface Props {
  label: string
  required?: boolean
  error?: boolean
  className?: string
}
export const Label = ({ label, required, error, className }: Props) => {
  return (
    <label
      className={cn(
        'text-sm font-semibold leading-loose text-foreground',
        !!error ? 'text-red-600' : '',
        className
      )}
    >
      {`${label}${required ? '*' : ''}`}
    </label>
  )
}
